export const environment = {
  production: false,
  origin: '',
  webApiUrl: 'webapi/api',
  protocol: '',
  currency: 'EUR'
};
